import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { LocalizeProvider } from 'react-localize-redux';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../global/muiTheme';

export const storeShape = PropTypes.shape({
    getState: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
});

export default function AuthPageShell({ store, children }) {
    return (
        <Provider store={store}>
            <LocalizeProvider store={store}>
                <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </LocalizeProvider>
        </Provider>
    );
}

AuthPageShell.propTypes = {
    store: storeShape.isRequired,
    children: PropTypes.node.isRequired,
};
